export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
        resource: 'Auth',
        action: 'read'
      },
      {
        title: 'Second Page',
        route: 'second-page',
        icon: 'FileIcon',
        resource: 'Auth',
        action: 'read'
      }
    ]
  }
]
